class CoachEditController {
	constructor(CoachesFactory, MiscFactory, $rootScope, $filter, $state, $stateParams, ngDialog, URLS){
		'ngInject';
		const vm = this;

		let $date = $filter('date');

		let $translate = $filter('translate');

		vm.levels = [
			{
				value: 0,
				name:$translate('COACH_0_LEVEL')
			},
			{
				value: 1,
				name:$translate('COACH_A_LEVEL')
			},
			{
				value: 2,
				name:$translate('COACH_B_LEVEL')
			},
			{
				value: 3,
				name:$translate('COACH_C_LEVEL')
			}
		];

		let dateTimePickerDefaultConfig = {
			startView: 'day',
			minView: 'day',
		};

		vm.coachId = $stateParams.id;
		vm.rootScope = $rootScope;
		vm.datePickerBirthConfig = Object.assign(dateTimePickerDefaultConfig, {dropdownSelector: '#date_filed'});

		vm.$onInit = () => {
			vm.coach = {};
			if(vm.coachId){
				CoachesFactory.getOne(vm.coachId).then(response => {
					vm.coach = response.data;
					vm.coach.active = (vm.coach.active === 1);
					vm.coach.level = vm.levels.find(l => l.value === vm.coach.level)
				});
			}
		};

		vm.submit = () => {
			vm.coach.active = vm.coach.active ? 1 : 0;
			vm.coach.level = vm.coach.level.value;
			vm.coach.date_filed = $date(vm.coach.date_filed, 'yyyy-MM-dd');
			if(vm.coach.id){
				/* UPDATE MATCH */
				CoachesFactory.update(vm.coach.id, vm.coach).then(response => {
					ngDialog.open({template: 'successTemplate'});
					$state.reload();
				});
			}else{
				/* NEW MATCH */
				CoachesFactory.create(vm.coach).then(response => {
					ngDialog.open({template: 'successTemplate'});
					$state.go('coach-edit', {id: response.data.id});
				});
			}
		};

		vm.getCoachImage = () =>{
			if(vm.coach.img){
				return URLS.IMAGES_URL + "/coaches/" + vm.coach.img;
			}else{
				return 'assets/images/no_avatar.png';
			}
		};

		vm.goToProfile = () =>{
			$state.go('coach-profile',{id:vm.coachId});
		};
	}
}

export default CoachEditController;



// WEBPACK FOOTER //
// ./client/app/components/coaches/coachEdit/coachEdit.controller.js